import { render } from "./parseExceptionComponent.vue?vue&type=template&id=1ec8ea7a&scoped=true"
import script from "./parseExceptionComponent.vue?vue&type=script&lang=js"
export * from "./parseExceptionComponent.vue?vue&type=script&lang=js"

import "./parseExceptionComponent.vue?vue&type=style&index=0&id=1ec8ea7a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec8ea7a"]])

export default __exports__